import { ModalContentTypes } from "../constants/modal-content-types";
import { ModalContentService } from "../modal-content/modal-content.service";

export const openModalWhatsInside = (productName: string, bundleItems: any[], modalContentService: ModalContentService) => {
    const items: string[] = [];
    bundleItems.forEach((item: any) => {
        items.push(`
        <div class="row d-flex justify-content-between p-3 py-1 animated fadeIn">
          <div class="col-8">
            <h6 class="h8-semibold text-start d-flex align-items-center gap-2">${item.name} ${item.packageName ? (' | ' +
                item.packageName) : (item.display ? (' | ' + item.display) : '')}
              ${item?.isPremiumAddon ? `<span class="material-symbols-outlined text-primary h6-size">verified</span>` : ''}
            </h6>
          </div>
          <div class="col-4">
            <h6 class="h8-semibold text-end">${item.quantity}</h6>
          </div>
        </div>
        `);
    });

    modalContentService.openModal(ModalContentTypes.CONFIRMATION, {
        title: productName,
        textContent: `<div class="bg-opacity-10 pt-2 rounded-4">${items.join('')}</div>`,
        confirmButtonText: 'Continue',
    }, { size: 'md' });
}